export const CHART_TYPES = {
	LINE_CHART: 1,
	BAR_CHART: 2
}